/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLendable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.477 2 15.21 6.853l4.384 5.414c1.385 2.012 1.784 4.5 1.027 6.718l-.097.265c-.654 1.687-1.751 2.75-3.36 2.75H6.836c-1.61 0-2.707-1.063-3.362-2.75-.884-2.284-.51-4.89.935-6.988l4.378-5.409L6.523 2zm-3.999 6h-2.957l-4.468 5.401C5 15 4.702 16.88 5.339 18.526 5.728 19.528 6.215 20 6.836 20h10.328c.62 0 1.108-.472 1.496-1.473.638-1.646.34-3.527-.711-5.123zm1.045-4H9.477l1.2 2h2.646z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLendable as Lendable };
